/**
 * Client-side dedup for recurring-task REMINDER emails (not escalation).
 * Keyed by `(taskId, dueDate)` — one gentle reminder per occurrence period.
 */

import { taskId as getTaskId } from './task-config'

const STORAGE_KEY = 'taskModuleReminderNotified.v1'

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : {}
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (e) {
    return {}
  }
}

function writeStore(store) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store))
  } catch (e) {
    console.warn('[task-reminder-store] could not persist notified reminder:', e)
  }
}

/** True when a reminder was already sent for this task at its current due date. */
export function wasReminderSent(task) {
  const id = getTaskId(task)
  if (id == null) return false
  const store = readStore()
  const record = store[String(id)]
  return !!(record && record.dueDate === (task.dueDate || null))
}

/** Record that a reminder email was sent for this task at its current due date. */
export function recordReminderSent(task) {
  const id = getTaskId(task)
  if (id == null) return
  const store = readStore()
  store[String(id)] = { dueDate: task.dueDate || null, sentAt: new Date().toISOString() }
  writeStore(store)
}

/** Drop dedup state when a task is marked Done. */
export function clearReminderSent(task) {
  const id = getTaskId(task)
  if (id == null) return
  const store = readStore()
  const key = String(id)
  if (!store[key]) return
  delete store[key]
  writeStore(store)
}

export default {
  wasReminderSent,
  recordReminderSent,
  clearReminderSent,
}
